module.exports = __webpack_public_path__ + "img/semiRing2.49eb3be9.svg";